<template>
  <div class="opc-nav__back" v-if="visible">
    <zm-button data-testid="checkout-button-32" ghost @click="back">
      <i class="zm-icon-left" />
      {{ backContent || $t('common.btn_back') }}
    </zm-button>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    backHandler: {
      type: Function,
    },
    backContent: {
      type: String,
    }
  },
  computed: {
    hasHistory() {
      return window.history && window.history.length > 1;
    }
  },
  methods: {
    back() {
      this.backHandler ? this.backHandler() : window.history.back();
    },
  },
};
</script>

<style lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';

$color: #515079;
.opc-nav__back {
  width: 100%;
  text-align: left;
  color: $color;
  display: flex;
  align-items: center;

  @include media(mobile,tablet) {
    margin-bottom: 12px;
  }

  .zm-button {
    color: $color;
    padding-left: 5px;
    padding-right: 5px;
    .zm-button__slot {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
}
</style>
